enum ProposalState {
  DRAFT = "DRAFT",
  OPEN_BID = "OPEN_BID",
  /** @deprecated - No longer used in new flow */
  AWAITING_CHEF_CONFIRMATION = "AWAITING_CHEF_CONFIRMATION",
  ACCEPTED_BOOKED = "ACCEPTED_BOOKED",
  INVOICE_CHANGE = "INVOICE_CHANGE",
  FINISHED_AND_PAID = "FINISHED_AND_PAID",
  COMPLETED = "COMPLETED",
  NEW_GIG = "NEW_GIG",
  DECLINED_BID = "DECLINED_BID",
  DEPOSIT_PAID = "DEPOSIT_PAID",
  PAID = "PAID",
  PENDING = "PENDING",
  /** @deprecated - No longer used in new flow */
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  CANCELED_BID = "CANCELED_BID",
  CANCELED_GIG = "CANCELED_GIG",
  NONE = "NONE",
  LIKED = "LIKED",
}

export default ProposalState;
